import { format } from "date-fns";

export const formatRadiologyDate = (dateString) => {
  if (!dateString) return "-";
  try {
    return dateString.split(" ")[0];
  } catch {
    return "-";
  }
};

export const formatCommonDate = (dateString) => {
  if (!dateString) return "-";
  try {
    const datePart = dateString.split(" ")[0];
    return format(new Date(datePart), "dd-MM-yyyy");
  } catch {
    return "-";
  }
};

export const getPatientName = (row) =>
  row.patient
    ? `${row.patient.firstName} ${row.patient.surname}`
    : row.patientInformationExternal?.fullName || "Unknown Patient";

export const parseResultValue = (value) => {
  if (!value) return null;
  return value.split(/\\\.br\\/g).filter((line) => line.trim());
};

export const formatResultDate = (dateString) => {
  if (!dateString) return "-";
  try {
    const datePart = dateString.split(" ")[0].replace(/\//g, "-");
    return format(new Date(datePart), "dd-MM-yyyy");
  } catch {
    return "-";
  }
};
